import * as ReactService from "@intech/react-service";
import { FichaFechamentoEntidade } from "../entidades/FichaFechamentoEntidade";

class FichaFechamento extends ReactService.BaseService {
  constructor() {
    super("FichaFechamento");
  }

  BuscarSaldoPorPlano = (cdPlano: string) =>
    this.CreateRequest<FichaFechamentoEntidade>(ReactService.RequestType.GET, `BuscarSaldoPorPlano/${cdPlano}`);

  BuscarDatasExtrato = (cdPlano: string) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `BuscarDatasExtrato/${cdPlano}`);

}

export const FichaFechamentoService = new FichaFechamento();
